module.exports = __webpack_public_path__ + "static/img/img35.e285b22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img35.png
// module id = TbHx
// module chunks = 1